import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { Product } from "src/app/api/models";
import { ProductService } from "src/app/shared/services/product.service";

@Component({
  selector: "app-cart-products",
  templateUrl: "./cart-products.component.html",
  styleUrls: ["./cart-products.component.scss"],
})
export class CartProductsComponent implements OnInit {
  cartProducts: Product[];
  totalValue: number;
  // cartProducts = new Subject<Product[]>();
  // totalValue = new Subject<number>();

  showDataNotFound = true;

  // Not Found Message
  messageTitle = "Nessun Presepe Trovato nel Carrello";
  messageDescription = "Aggiungi Presepi al Carrello!";

  constructor(public productService: ProductService,
    private router: Router) {}

  ngOnInit() {
    this.getCartProduct();
  }

  removeCartProduct(product: Product) {
    this.productService.removeLocalCartProduct(product);

    // Recalling
    this.getCartProduct();
  }
  decreaseProductQuantity(product: Product){
    this.productService.decreaseProductQuantity(product.product_id)
    this.getCartProduct();
  }

  increaseProductQuantity(product: Product){
    this.productService.increaseProductQuantity(product.product_id)
    this.getCartProduct();
  }

  getCartProduct() {
    this.cartProducts = [...this.productService.getLocalCartProducts()];

    let total = 0;
    this.cartProducts.forEach((product) => {
        total += product.price * this.productService.getProductQuantity(product.product_id)
    });
    this.totalValue = total;
  }
}
